const DEFAULT_PEOPLE = 2;

export default DEFAULT_PEOPLE;
